export default {


    // baseUrl : 'http://36958q16l7.qicp.vip/', // 本地/
    // baseUrl : 'http://192.168.0.85:5000/', // 本地/
    // baseUrl : 'http://192.168.0.202:5000/', // 本地/ 

    // imageUrl : 'http://192.168.1.152:8088/image', //图片前缀地址 
    // baseUrl: 'http://39.98.153.82:5000', // 外网
    baseUrl:'https://guitars.qugaotech.com/'
    // baseUrl: 'http://192.168.0.136:5000'


}